export var CommitmentType;
(function (CommitmentType) {
    CommitmentType["DonorMatching"] = "Donor Match";
    CommitmentType["PartnershipMatching"] = "Partnership Donation - Matching";
})(CommitmentType || (CommitmentType = {}));
